module.exports = __webpack_public_path__ + "img/linkedIn.c9c5aca2.svg";